// @ts-nocheck
import * as Types from '../../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import { VersionableFragmentDoc } from '../../../../components/ReadyPlanVersionHeader.generated';
import { ReadyPlanLikeButtonMenuAggregateDraftFragmentDoc } from '../../../../components/ReadyPlanButtonMenu.generated';
import { PotentialOperationDetailsFragmentDoc } from '../../../../queries/fragments.generated';
import * as ApolloReactCommon from 'src/apolloHooks';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type PlanPackagesQueryVariables = Types.Exact<{
  filter: Types.PlanPackageFilter;
}>;


export type PlanPackagesQuery = { __typename?: 'Query', planPackages: { __typename?: 'PlanPackagesPageResult', pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, totalCount: number, nextPage?: { __typename?: 'Page', limit: number, offset: number } | null | undefined }, entities: Array<{ __typename?: 'PlanPackage', id: string, name: string, displayName: string, description?: string | null | undefined, updatedAt: Types.Scalars['DateTime']['input'], activeOptionsCount: number, displayCode?: string | null | undefined, type: { __typename?: 'ReadyPlanTypeDetail', code: Types.ReadyPlanType }, status: { __typename?: 'ReadyPlanStatusDetail', code: Types.ReadyPlanStatus, name: string }, maxProgramData: { __typename?: 'ProgramData', id: string, bedrooms?: number | null | undefined, fullBaths?: number | null | undefined, halfBaths?: number | null | undefined, sellableSqft?: number | null | undefined }, minProgramData: { __typename?: 'ProgramData', id: string, bedrooms?: number | null | undefined, fullBaths?: number | null | undefined, halfBaths?: number | null | undefined, sellableSqft?: number | null | undefined }, options: Array<{ __typename?: 'ReadyPlanOption', id: string, name: string, type: { __typename?: 'GlobalOptionType', id: string, isElevation: boolean } }>, aggregateLatest: { __typename?: 'ReadyPlanAggregateVersion', id: string, displayName: string, displayVersion: string }, aggregateVersions: Array<{ __typename?: 'ReadyPlanAggregateVersion', id: string, version?: number | null | undefined, status: { __typename?: 'AggregateVersionStatusDetail', code: Types.AggregateVersionStatus, name: string } }>, assets: Array<{ __typename?: 'ReadyPlanAsset', id: string, asset: { __typename?: 'Asset', id: string, previewUrl?: string | null | undefined }, type: { __typename?: 'ReadyPlanAssetTypeDetail', code: Types.ReadyPlanAssetType } }>, aggregateDraft?: { __typename?: 'ReadyPlanAggregateVersion', id: string, version?: number | null | undefined, promotedAt?: Types.Scalars['DateTime']['input'] | null | undefined, displayVersion: string, promotedBy?: { __typename?: 'User', id: string, name: string } | null | undefined, status: { __typename?: 'AggregateVersionStatusDetail', code: Types.AggregateVersionStatus }, canDelete: { __typename?: 'PotentialOperation2', allowed: boolean, disabledReasons: Array<{ __typename?: 'Reason', message: string }> } } | null | undefined, canEdit: { __typename?: 'PotentialOperation2', allowed: boolean, disabledReasons: Array<{ __typename?: 'Reason', message: string }> } }> } };

export type PlanPackageFragment = { __typename?: 'PlanPackage', id: string, name: string, displayName: string, description?: string | null | undefined, updatedAt: Types.Scalars['DateTime']['input'], activeOptionsCount: number, displayCode?: string | null | undefined, type: { __typename?: 'ReadyPlanTypeDetail', code: Types.ReadyPlanType }, status: { __typename?: 'ReadyPlanStatusDetail', code: Types.ReadyPlanStatus, name: string }, maxProgramData: { __typename?: 'ProgramData', id: string, bedrooms?: number | null | undefined, fullBaths?: number | null | undefined, halfBaths?: number | null | undefined, sellableSqft?: number | null | undefined }, minProgramData: { __typename?: 'ProgramData', id: string, bedrooms?: number | null | undefined, fullBaths?: number | null | undefined, halfBaths?: number | null | undefined, sellableSqft?: number | null | undefined }, options: Array<{ __typename?: 'ReadyPlanOption', id: string, name: string, type: { __typename?: 'GlobalOptionType', id: string, isElevation: boolean } }>, aggregateLatest: { __typename?: 'ReadyPlanAggregateVersion', id: string, displayName: string, displayVersion: string }, aggregateVersions: Array<{ __typename?: 'ReadyPlanAggregateVersion', id: string, version?: number | null | undefined, status: { __typename?: 'AggregateVersionStatusDetail', code: Types.AggregateVersionStatus, name: string } }>, assets: Array<{ __typename?: 'ReadyPlanAsset', id: string, asset: { __typename?: 'Asset', id: string, previewUrl?: string | null | undefined }, type: { __typename?: 'ReadyPlanAssetTypeDetail', code: Types.ReadyPlanAssetType } }>, aggregateDraft?: { __typename?: 'ReadyPlanAggregateVersion', id: string, version?: number | null | undefined, promotedAt?: Types.Scalars['DateTime']['input'] | null | undefined, displayVersion: string, promotedBy?: { __typename?: 'User', id: string, name: string } | null | undefined, status: { __typename?: 'AggregateVersionStatusDetail', code: Types.AggregateVersionStatus }, canDelete: { __typename?: 'PotentialOperation2', allowed: boolean, disabledReasons: Array<{ __typename?: 'Reason', message: string }> } } | null | undefined, canEdit: { __typename?: 'PotentialOperation2', allowed: boolean, disabledReasons: Array<{ __typename?: 'Reason', message: string }> } };

export type PlanPackageProgramDataLiteFragment = { __typename?: 'ProgramData', id: string, bedrooms?: number | null | undefined, fullBaths?: number | null | undefined, halfBaths?: number | null | undefined, sellableSqft?: number | null | undefined };

export const PlanPackageProgramDataLiteFragmentDoc = gql`
    fragment PlanPackageProgramDataLite on ProgramData {
  id
  bedrooms
  fullBaths
  halfBaths
  sellableSqft
}
    `;
export const PlanPackageFragmentDoc = gql`
    fragment PlanPackage on PlanPackage {
  id
  name
  displayName
  description
  updatedAt
  activeOptionsCount
  displayCode
  type {
    code
  }
  status: effectiveStatus {
    code
    name
  }
  maxProgramData {
    ...PlanPackageProgramDataLite
  }
  minProgramData {
    ...PlanPackageProgramDataLite
  }
  options {
    id
    name
    type {
      id
      isElevation
    }
  }
  aggregateLatest {
    id
    displayName
    displayVersion
  }
  aggregateVersions {
    id
    version
    status {
      code
      name
    }
  }
  assets {
    id
    asset {
      id
      previewUrl(resizing: {width: 321, region: FULL})
    }
    type {
      code
    }
  }
  aggregateDraft {
    ...Versionable
    ...ReadyPlanLikeButtonMenuAggregateDraft
  }
  canEdit {
    ...PotentialOperationDetails
  }
}
    ${PlanPackageProgramDataLiteFragmentDoc}
${VersionableFragmentDoc}
${ReadyPlanLikeButtonMenuAggregateDraftFragmentDoc}
${PotentialOperationDetailsFragmentDoc}`;
export const PlanPackagesDocument = gql`
    query PlanPackages($filter: PlanPackageFilter!) {
  planPackages(filter: $filter) {
    pageInfo {
      hasNextPage
      totalCount
      nextPage {
        limit
        offset
      }
    }
    entities {
      ...PlanPackage
    }
  }
}
    ${PlanPackageFragmentDoc}`;

/**
 * __usePlanPackagesQuery__
 *
 * To run a query within a React component, call `usePlanPackagesQuery` and pass it any options that fit your needs.
 * When your component renders, `usePlanPackagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePlanPackagesQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function usePlanPackagesQuery(baseOptions: ApolloReactHooks.QueryHookOptions<PlanPackagesQuery, PlanPackagesQueryVariables> & ({ variables: PlanPackagesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<PlanPackagesQuery, PlanPackagesQueryVariables>(PlanPackagesDocument, options);
      }
export function usePlanPackagesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<PlanPackagesQuery, PlanPackagesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<PlanPackagesQuery, PlanPackagesQueryVariables>(PlanPackagesDocument, options);
        }
// @ts-ignore
export function usePlanPackagesSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<PlanPackagesQuery, PlanPackagesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<PlanPackagesQuery, PlanPackagesQueryVariables>;
export function usePlanPackagesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<PlanPackagesQuery, PlanPackagesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<PlanPackagesQuery | undefined, PlanPackagesQueryVariables>;
export function usePlanPackagesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<PlanPackagesQuery, PlanPackagesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<PlanPackagesQuery, PlanPackagesQueryVariables>(PlanPackagesDocument, options);
        }
export type PlanPackagesQueryHookResult = ReturnType<typeof usePlanPackagesQuery>;
export type PlanPackagesLazyQueryHookResult = ReturnType<typeof usePlanPackagesLazyQuery>;
export type PlanPackagesSuspenseQueryHookResult = ReturnType<typeof usePlanPackagesSuspenseQuery>;
export type PlanPackagesQueryResult = ApolloReactCommon.QueryResult<PlanPackagesQuery, PlanPackagesQueryVariables>;